import { site, enabledServices } from "@/config/site";
import { SEO, breadcrumbLd } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTA } from "@/components/CTA";
import { ServiceCard } from "@/components/ServiceCard";

export default function Services() {
  return (
    <>
      <SEO
        title="Painting Services in Delta, BC | North Ember Painting"
        description="Interior, exterior, residential and commercial painting, cabinet refinishing, trim, deck and fence staining in Delta, Ladner, Tsawwassen and Surrey. Fully insured — free estimates."
        path="/services"
        jsonLd={[breadcrumbLd([{ name: "Home", path: "/" }, { name: "Painting Services", path: "/services" }])]}
      />
      <PageHero
        eyebrow="Painting services"
        title="Every surface, prepared and finished properly"
        intro={`From a single feature wall to a full commercial repaint, North Ember Painting brings the same preparation-first approach to every project across Delta, Ladner, Tsawwassen and Surrey.`}
        image="painterCeiling"
      />
      <section className="py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {enabledServices.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 3) * 70}>
                <ServiceCard service={s} />
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12">
            <p className="max-w-2xl text-sm leading-relaxed text-slate-500">
              Not sure which service fits your project? Call or message any time at{" "}
              <a href={site.phoneHref} className="font-semibold text-ember-dark">{site.phone}</a> — we'll help you
              scope it honestly.
            </p>
          </Reveal>
        </div>
      </section>
      <CTA />
    </>
  );
}
